import React from "react";

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", danger = false }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-start sm:items-center justify-center z-[100] px-4 overflow-y-auto"
      style={{
        paddingTop: 'calc(env(safe-area-inset-top, 0px) + 1rem)',
        paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)'
      }}
    >
      <div className="bg-[#0a0a0f] border border-white/10 rounded-2xl p-6 sm:p-8 max-w-md w-full shadow-2xl my-auto">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">{title}</h2>
        <p className="text-gray-300 mb-6 sm:mb-8 leading-relaxed text-sm sm:text-base">{message}</p>

        <div className="flex flex-col sm:flex-row gap-3 justify-end">
          <button
            onClick={onClose}
            className="w-full sm:w-auto px-6 py-2.5 rounded-lg bg-white/5 border border-white/10 text-gray-300 hover:bg-white/10 hover:text-gray-100 transition font-medium text-sm sm:text-base order-2 sm:order-1"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`w-full sm:w-auto px-6 py-2.5 rounded-lg transition font-medium text-sm sm:text-base order-1 sm:order-2 ${
              danger
                ? "bg-red-500 hover:bg-red-600 text-white"
                : "bg-[#0A2472] hover:bg-[#0d2d8a] text-white"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
